import classNames from 'classnames';
import styles from './Spinner.module.css';

const Spinner = ({ size = 'md', fullScreen = false }) => {
  const spinnerClasses = classNames(
    styles.spinner,
    styles[size],
    {
      [styles.fullScreen]: fullScreen,
    }
  );

  if (fullScreen) {
    return (
      <div className={styles.fullScreenContainer}>
        <div className={spinnerClasses} role="status" aria-label="Loading">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={spinnerClasses} role="status" aria-label="Loading">
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
